import { Component } from '@angular/core';
import { RelatorioApresentacaoComponent } from '../relatorio-apresentacao/relatorio-apresentacao.component';
import { FeatureFlagService } from "../../services/feature-flag/feature-flag.service";
import { NgIf } from "@angular/common";

@Component({
  selector: 'app-relatorio-receitas-despesas-apresentacao-wrapper',
  standalone: true,
  imports: [RelatorioApresentacaoComponent, NgIf],
  styleUrl: './relatorio-receitas-despesas-apresentacao-wrapper.component.css',
  template: `
    <app-relatorio-apresentacao
      [breadcrumb]="'Módulo Receitas e Despesas'"
      [breadcrumbColor]="'#7FA6BF'"
      [iconeHero]="'assets/ilustrations/r5-receitas-despesas.svg'"
      [subtituloHero]="'Módulo'"
      [corSubtituloHero]="'#FEBE0D'"
      [tituloHero]="'Receitas e despesas da Educação Básica'"
      [corTituloHero]="'#FEBE0D'"
      [descricaoHero]="
         '<p>Este módulo apresenta as seguintes informações sobre a composição de Receitas e Despesas em Educação Básica.<br/>        (1) Receita Potencial mínima Vinculada à Educação (RPEb) detalhada por item;<br/>    (2) Receita-aluno mês ;<br/>    (3) Despesa necessária detalhada por item;<br/>    (4) Valor do CAQ mês;<br/>    (5) Complementação necessária para financiar o PQR;<br/>    (6) Despesa de capital necessária;<br/>    (7) Despesa líquida realizada.<br/></p>'
      "
      [textoBotaoHero]="'Acessar resultados'"
      [corBotaoHero]="'transparent'"
      [corTextoBotaoHero]="'#FEBE0D'"
      [linkBotaoHero]="'/selecionar-local-R5'"
      [imagemHero]="'assets/imagens/child-writing.svg'"
      [backgroundHero]="'assets/ilustrations/circles-background-1.png'"
      [infoIcone]="[]"
      [infoTexto]="[]"
      [tituloCta]="
        'Que tal verificar os resultados financeiros para a sua rede de ensino?'
      "
      [textoBotaoCta]="'Começar a usar'"
      [corBotaoCta]="'#FEBE0D'"
      [corTextoBotaoCta]="'#2F4858'"
      [linkBotaoCta]="'/selecionar-local-R5'"
      [corSetaHero]="'#FEBE0D'"
      [corSetaCta]="'#2F4858'"
    ></app-relatorio-apresentacao>
  `,
})
export class RelatorioReceitasDespesasApresentacaoWrapperComponent {
  featureFlagService: any;
  constructor(featureFlagService: FeatureFlagService) {
    this.featureFlagService = featureFlagService;
  }
}
